import CurrentPromptCanShow from '@ms/yammer-web-components/dist/dismissablePromptView/CurrentPromptCanShow';
import React, { FC } from 'react';

import VivaEngageRebrandingDialog from './LoadableVivaEngageRebrandingDialog';
import { useGetRebrandingDialogPromptKey, useShouldShowRebrandingDialog } from './hooks';

const VivaEngageRebranding: FC = () => {
  const shouldShowRebrandingDialog = useShouldShowRebrandingDialog();
  const promptKey = useGetRebrandingDialogPromptKey();

  if (!shouldShowRebrandingDialog) {
    return null;
  }

  return (
    <CurrentPromptCanShow promptKey={promptKey}>
      <VivaEngageRebrandingDialog />
    </CurrentPromptCanShow>
  );
};

export default VivaEngageRebranding;
